import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import {Route} from "react-router-dom"

import {NestedRoute, IndexRedirect} from "@irati/utils/history/routing"
import AppContainer from "@irati/ui/src/AppContainer"
import {HasPermissionTo} from "@irati/utils/permissions"
import {AuthedCheckerContext, SetAuthStatus} from "@irati/utils/history/routing/AuthedChecker"
import Loading from "@irati/ui/src/Loading"
import {doIHavePermission} from "@irati/utils/permissions/HasPermissionTo"
import auth from "@irati/auth"

import {ScheduleSettingsRoutes, WizardRoutes} from "./nested"
import sitemap from "./sitemap"
import {Homepage, Reports} from "./pages"
import {RequiredByInsights} from "../components/Required"
import ScheduleEdit from "./pages/ScheduleEdit"
import ScheduleEditSummary from "./pages/ScheduleEditSummary"
import AnalysisController from "./pages/AnalysisController"
import Chatroom from "./pages/Chatroom"
import {MyUserSurveys} from "../components/MyUserSurveys"

class RouteContainer extends Component {
  static propTypes = {
    path: PropTypes.string.isRequired
  }

  render() {
    const {path} = this.props
    return (
      <Route
        path={path}
        render={() => (
          <AppContainer isFlush>
            <AuthedCheckerContext.Consumer>
              {({load, setAuthed}) => (
                <Fragment>
                  <SetAuthStatus setAuthed={setAuthed} />
                  <Loading load={load}>
                    <HasPermissionTo permissions="insights.survey">
                      <HasPermissionTo permissions="insights.chatroom" Error={null}>
                        <NestedRoute exact match={path} {...sitemap.chatroom} component={Chatroom} />
                      </HasPermissionTo>

                      <NestedRoute match={path} {...sitemap.mySurveys} component={MyUserSurveys} />

                      <HasPermissionTo
                        permissions="insights.admin"
                        Error={doIHavePermission("insights.survey", auth.apps()) ? null : undefined}>
                        <RequiredByInsights>
                          <NestedRoute match={path} {...sitemap.homepage} component={Homepage} />

                          <HasPermissionTo permissions="insights.reports" Error={null}>
                            <NestedRoute match={path} {...sitemap.reports} component={Reports} />
                          </HasPermissionTo>

                          <NestedRoute match={path} {...sitemap.scheduleAdd} component={WizardRoutes} useGrid={false} />

                          <HasPermissionTo
                            permissions="insights.admin"
                            Error={
                              <NestedRoute match={path} {...sitemap.scheduleEdit} component={ScheduleSettingsRoutes} useGrid={false} />
                            }>
                            <NestedRoute exact match={path} {...sitemap.scheduleEdit} component={ScheduleEdit} useGrid={false} />
                          </HasPermissionTo>

                          <HasPermissionTo permissions="insights.admin" Error={null}>
                            <NestedRoute
                              exact
                              match={path}
                              {...sitemap.scheduleEditSummary}
                              component={ScheduleEditSummary}
                              useGrid={false} />
                          </HasPermissionTo>

                          <NestedRoute match={path} {...sitemap.analysis} useGrid={false} component={AnalysisController} />

                          <IndexRedirect to={sitemap.homepage.path} />
                        </RequiredByInsights>
                      </HasPermissionTo>
                      <HasPermissionTo permissions="insights.admin" Error={<IndexRedirect to={sitemap.mySurveys.path} />} />
                    </HasPermissionTo>
                  </Loading>
                </Fragment>
              )}
            </AuthedCheckerContext.Consumer>
          </AppContainer>
        )} />
    )
  }
}

export default RouteContainer
